import { Stack } from '@chakra-ui/react'
import { ListEncodingPresets } from '@features/encodingPreset/components/ListEncodingPresets'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import {
  DEFAULT_ORDER,
  listEncodingPresetsRequestSchema,
} from '@customTypes/cloudmix/encodingPreset'
import { withListHydration } from '@lib/listState/withListHydration'

const EncodingPresetsRoute = () => (
  <Stack>
    <ListEncodingPresets />
  </Stack>
)

const routerSchema = listEncodingPresetsRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/o/$orgId/encodingPresets/')({
  component: EncodingPresetsRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {
      defaultSort: [DEFAULT_ORDER],
    },
    getTitle: () => 'Encoding Presets',
  }),
})
